import { Shark } from "shark-mvc";

import NousCoreModel from "./NousCoreModel";

class ContentCustomTags extends NousCoreModel {
	categoryGuid = "";
	contentGuid = "";
	tags = [];
	
	__tags = "";

	constructor (data) {
		super();

		if (data) {
			this.import(data);
		}
	}

	export () {
		const exportData = super.export();

		exportData.tags = this.exportArrayField("tags");
		
		return exportData;
	}

	import (data, options) {
		super.import(data, options);
		
		this.parseTags();
	}
	
	on__tagsChanged () {
		this.tags = this.__tags !== "" ? JSON.parse(this.__tags) : [];
		// console.log(this);
	}

	parseTags () {
		this.__tags = JSON.stringify(this.tags);
	}
}

Shark.registerModel("ContentCustomTags", ContentCustomTags);

export default ContentCustomTags;